import React from 'react';
export function TestimonialsSection() {
  return <section id="testimonios" className="py-20 w-full bg-white" aria-labelledby="testimonios-title" data-id="element-246">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-247">
        {/* Header */}
        <div className="text-center mb-14" data-id="element-248">
          <h2 id="testimonios-title" className="font-heading text-4xl sm:text-5xl font-bold text-navy-deep mb-4" data-id="element-249">
            Lo que dicen los Docentes
          </h2>
          <p className="text-gray-500 text-lg max-w-xl mx-auto" data-id="element-250">
            Colegas que ya transformaron sus clases con el Mega Pack.
          </p>
        </div>

        {/* Testimonial Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-251">
          {/* Card 1 */}
          <div className="bg-white rounded-2xl shadow-md p-8 border border-gray-100 flex flex-col" data-id="element-252">
            <div className="flex items-center gap-4 mb-5" data-id="element-253">
              <div className="w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl flex-shrink-0" style={{
              backgroundColor: '#1a2e4a',
              color: '#c9a84c'
            }} aria-label="Avatar de Laura G." data-id="element-254">
                L
              </div>
              <div data-id="element-255">
                <p className="font-bold text-navy-deep" data-id="element-256">Laura G.</p>
                <p className="text-gray-400 text-sm" data-id="element-257">Docente de Primaria</p>
              </div>
            </div>
            <div className="text-gold text-xl mb-4" aria-label="5 estrellas" data-id="element-258">
              ⭐⭐⭐⭐⭐
            </div>
            <blockquote className="text-gray-600 text-sm leading-relaxed flex-1" data-id="element-259">
              "¡Material increíble! Me salvó el año. Las actividades son súper
              completas y a los chicos les encantaron las dinámicas. Lo
              recomiendo totalmente."
            </blockquote>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-2xl shadow-md p-8 border border-gray-100 flex flex-col" data-id="element-260">
            <div className="flex items-center gap-4 mb-5" data-id="element-261">
              <div className="w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl flex-shrink-0" style={{
              backgroundColor: '#1a2e4a',
              color: '#c9a84c'
            }} aria-label="Avatar de Marcelo R." data-id="element-262">
                M
              </div>
              <div data-id="element-263">
                <p className="font-bold text-navy-deep" data-id="element-264">Marcelo R.</p>
                <p className="text-gray-400 text-sm" data-id="element-265">
                  Catequista Parroquial — Córdoba
                </p>
              </div>
            </div>
            <div className="text-gold text-xl mb-4" aria-label="5 estrellas" data-id="element-266">
              ⭐⭐⭐⭐⭐
            </div>
            <blockquote className="text-gray-600 text-sm leading-relaxed flex-1" data-id="element-267">
              "La sección de secundaria es muy completa. Los proyectos y la guía
              de Confirmación están muy bien estructurados paso a paso.
              Excelente inversión."
            </blockquote>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-2xl shadow-md p-8 border border-gray-100 flex flex-col" data-id="element-268">
            <div className="flex items-center gap-4 mb-5" data-id="element-269">
              <div className="w-12 h-12 rounded-full flex items-center justify-center font-bold text-xl flex-shrink-0" style={{
              backgroundColor: '#1a2e4a',
              color: '#c9a84c'
            }} aria-label="Avatar de Sofía P." data-id="element-270">
                S
              </div>
              <div data-id="element-271">
                <p className="font-bold text-navy-deep" data-id="element-272">Sofía P.</p>
                <p className="text-gray-400 text-sm" data-id="element-273">
                  Coordinadora de Religión — Rosario
                </p>
              </div>
            </div>
            <div className="text-gold text-xl mb-4" aria-label="5 estrellas" data-id="element-274">
              ⭐⭐⭐⭐⭐
            </div>
            <blockquote className="text-gray-600 text-sm leading-relaxed flex-1" data-id="element-275">
              "Uso los bonos todo el tiempo. El manual de manejo de aula me
              cambió las clases con secundaria. Me permite sostener el clima y
              la participación siempre."
            </blockquote>
          </div>
        </div>
      </div>
    </section>;
}